import React from "react";
import { Form, Label } from "semantic-ui-react";
import { UnControlled as CodeMirror } from "react-codemirror2";

require("codemirror/mode/javascript/javascript");

const CodeArea = ({ field, form, label, ...props }: any) => {
  return (
    <Form.Field>
      <label>{label}</label>
      <CodeMirror
        value={field.value}
        options={{
          mode: "javascript",
          theme: "material",
          lineNumbers: true,
        }}
        onBlur={(editor: any) => {
          form.setFieldValue(field.name, editor.getValue());
        }}
      />
      {form.touched[field.name] && form.errors[field.name] && (
        <Label basic pointing color='red'>
          {form.errors[field.name]}
        </Label>
      )}
    </Form.Field>
  );
};

export default CodeArea;
